import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Card": Card, "@mui/material/Box": Box, "@mui/material/Chip": Chip, "@mui/material/Stack": Stack, "@mui/material/Divider": Divider, "@mui/material/Typography": Typography } } });
export default ClientProvider;
